module.exports = __webpack_public_path__ + "img/rule_bg.8ed2b4f1.jpg";